import { StateCreator } from 'zustand';

export enum ColorMode {
  Dark = 'dark',
  Light = 'light',
}

type State = {
  colorMode: ColorMode;
};

type Actions = {
  toggleColorMode: () => void;
};

export type ColorModeSlice = State & Actions;

const STORAGE_KEY = 'colorMode';

const getStoredColorMode = (): ColorMode =>
  localStorage.getItem(STORAGE_KEY) === ColorMode.Light ? ColorMode.Light : ColorMode.Dark;

const applyHtmlClass = (mode: ColorMode) =>
  document.getElementsByTagName('html')[0].classList.toggle('dark', mode === ColorMode.Dark);

export const createColorModeSliceSlice: StateCreator<ColorModeSlice, [['zustand/immer', never]], [], ColorModeSlice> = (
  set,
) => {
  const initialColorMode = getStoredColorMode();
  applyHtmlClass(initialColorMode);

  return {
    colorMode: initialColorMode,
    toggleColorMode: () =>
      set((state) => {
        const nextColorMode = state.colorMode == ColorMode.Dark ? ColorMode.Light : ColorMode.Dark;
        applyHtmlClass(nextColorMode);
        localStorage.setItem(STORAGE_KEY, nextColorMode);

        return { colorMode: nextColorMode };
      }),
  };
};
